<template>
  <v-container class="pa-0">
    <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
      <page-header-title :title="page_title"></page-header-title>

      <v-spacer></v-spacer>

      <action-button type="back" @click="$router.go(-1)" />

      <router-link
        :to="{
          path: BACKEND_URL + '/tennants/edit/' + tennant.id,
          props: { id: tennant.id }
        }"
        v-if="$can('tennant-edit')"
      >
        <action-button type="edit" />
      </router-link>

      <action-button
        v-if="tennant.is_setup != 1"
        type="default"
        @click="setup(tennant.id)"
        :text="$t('tennants.setup')"
        color="info"
        icon="fas fa-tools"
      />

      <action-button type="delete" @click="del(tennant.id)" v-if="$can('tennant-delete')" />
    </v-app-bar>

    <v-form ref="form">
      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  v-model="organisation.name"
                  :label="$t('organisations.title')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="tennant.subdomain"
                  v-model="tennant.subdomain"
                  :label="$t('tennants.subdomain')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="tennant.active_from"
                  v-model="tennant.active_from"
                  :label="$t('tennants.active_from')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="tennant.payed_for_users"
                  v-model="tennant.payed_for_users"
                  :label="$t('tennants.payed_for_users')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="tennant.inactive_from"
                  v-model="tennant.inactive_from"
                  :label="$t('tennants.inactive_from')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="tennant.status"
                  :value="this.$dd_tennant_status(tennant.status)"
                  :label="$t('tennants.status')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <v-card class="mt-4">
          <v-app-bar flat dense color="secondary">
            <v-toolbar-title class="subheading">{{ $t("tennants.database_title") }}</v-toolbar-title>
          </v-app-bar>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="tennant.dbname"
                  v-model="tennant.dbname"
                  :label="$t('tennants.dbname')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="tennant.master_username"
                  v-model="tennant.master_username"
                  :label="$t('tennants.master_username')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="tennant.master_password"
                  v-model="tennant.master_password"
                  :label="$t('tennants.master_password')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="tennant.email"
                  v-model="tennant.email"
                  :label="$t('tennants.email')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "tennantView",

  props: ["id"],

  data() {
    return {
      page_title: "",
      tennant: {},
      organisation: {},
      active_from_menu: false,
      inactive_from_menu: false
    }
  },

  created() {
    this.page_title = this.$t("tennants.view_tennant")

    axios
      .get(this.API_URL + "tennant/" + this.id)
      .then((res) => {
        this.tennant = res.data.data
        this.organisation = res.data.data.organisation
      })
      .catch((err) => console.log(err))
  },

  methods: {
    setup(id) {
      let vm = this

      axios
        .put(this.API_URL + "tennant/setup/" + id)
        .then((res) => {
          this.tennant = res.data.data
          this.organisation = res.data.data.organisation

          vm.$awn.success(vm.$t("global.tenant_setup_success"))
        })
        .catch((err) => console.log(err))
    },

    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "tennant/" + id)
            .then((res) => {
              vm.$router.push(this.BACKEND_URL + "/tennants")
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },

    menu(value) {
      let vm = this

      switch (value) {
        case "download-env":
          this.$awn.confirm(
            this.$t("tennants.download_env_confirm"),
            () => {
              axios
                .get(vm.API_URL + "tennant/env/" + vm.id)
                .then((res) => {
                  const url = window.URL.createObjectURL(new Blob([res.data.content]))
                  const link = document.createElement("a")

                  link.href = url
                  link.setAttribute("download", res.data.filename)
                  document.body.appendChild(link)
                  link.click()
                })
                .catch((err) => console.log(err))
            },
            () => {
              return
            }
          )

          break
      }
    }
  }
}
</script>

<style scoped></style>
